<template>
  <div class="wrapper jobs-footer-2">
    <b-row class="m-0 p-0 footer-2-contents">
      <a
        href="https://www.facebook.com/planetajob"
        class="col social"
        target="_blank"
      >
        <font-awesome-icon
          id="icon-fb"
          class="social-icon"
          :icon="['fab', 'facebook-square']"
        />
      </a>
      <a
        href="https://www.linkedin.com/company/planeta-job"
        class="col social"
        target="_blank"
      >
        <font-awesome-icon
          id="icon-ln"
          class="social-icon"
          :icon="['fab', 'linkedin']"
        />
      </a>
      <a
        href="http://twitter.com/PlanetaJob"
        class="col social"
        target="_blank"
      >
        <font-awesome-icon
          id="icon-tw"
          class="social-icon"
          :icon="['fab', 'twitter']"
        />
      </a>
      <a
        href="https://www.instagram.com/planetajob"
        class="col social"
        target="_blank"
      >
        <font-awesome-icon
          id="icon-ig"
          class="social-icon"
          :icon="['fab', 'instagram']"
        />
      </a>
    </b-row>
    <div class="real-footer">
      <div class="row footer-nav">
        <div class="col-12 col-md-4">
          <div class="title">
            {{ $t('main.footer2.about-us.title', 'We') }}
          </div>
          <ul>
            <!-- <router-link to="">
              <li>{{ $t('main.footer2.about-us.about-us', 'About Us') }}</li>
            </router-link> -->
            <router-link :to="{ name: 'general-conditions' }">
              <li>{{ $t('main.footer2.about-us.general-conditions', 'Legal conditions') }}</li>
            </router-link>
            <router-link :to="{ name: 'privacy-policy' }">
              <li>{{ $t('main.footer2.about-us.privacy-policy', 'Privacy policy') }}</li>
            </router-link>
            <router-link :to="{ name: 'cookies-policy' }">
              <li>{{ $t('main.footer2.about-us.cookies-policy', 'Cookies policy') }}</li>
            </router-link>
          </ul>
        </div>
        <div class="col-12 col-md-4">
          <div class="title">
            {{ $t('main.footer2.on.title', 'About {portal}', {portal: appName}) }}
          </div>
          <ul>
            <router-link :to="{ name: 'Help' }">
              <li>{{ $t('main.footer2.about-us.help', 'Use of the service') }}</li>
            </router-link>
            <!-- <a
              href="https://www.aicad.es/ofertas-de-trabajo/"
              target="_blank"
            >
              <li>{{ $t('main.footer2.on.work-with-us', 'Work with us') }}</li>
            </a> -->
          </ul>
        </div>
        <div class="col-12 col-md-4">
          <div class="title">
            {{ $t('main.footer2.vip-services.title', 'VIP services') }}
          </div>
          <ul>
            <router-link :to="{ name: 'recruitment' }">
              <li>{{ $t('main.footer2.vip-services.recruitment', 'Successful recruitment and selection') }}</li>
            </router-link>
          </ul>
        </div>
      </div>
      <hr class="mt-0 mb-5">
      <!-- TODO: move logo out to a config -->
      <div class="mb-5">
        <img
          v-if="appName === 'Planetajob'"
          class="logo-dark --footer"
          stytle="width: 100%;"
          src="@/assets/planetajob_logo_dark.png"
        >
        <img
          v-if="appName === 'Aicad Jobs'"
          style="height: 80px;"
          src="@/assets/aicad_logo_dark.png"
        >
        <div class="my-3 group-company">
          {{ $t('main.footer2.group-company', 'Is a company of group') }}
        </div>
        <img
          src="@/assets/aicad-business-school-logo.png"
          style="height: 40px;"
        >
        <div class="mt-4 mb-3 group-company">
          {{ $t('main.footer2.our-brands', 'Our brands') }}
        </div>
        <img
          src="@/assets/marcas_aicad.png"
          style="width: 80%"
        >
      </div>
      <div class="row copyright">
        © {{ appName }} {{ new Date().getFullYear() }}
        <router-link :to="{ path: '/'}">
          {{ $t('generic.home', 'Home') }}
        </router-link>
        <router-link :to="{ name: 'general-conditions' }">
          {{ $t('main.footer2.about-us.general-conditions', 'Legal conditions') }}
        </router-link>
        <router-link :to="{ name: 'cookies-policy' }">
          {{ $t('main.footer2.about-us.cookies-policy', 'Cookies policy') }}
        </router-link>
        <router-link :to="{ name: 'Help' }">
          {{ $t('main.footer.help', 'Help') }}
        </router-link>
      </div>

      <div class="version-text mt-5">
        <span class="mr-2">
          Version: {{ version }}
        </span>
        <span>
          Build date: {{ buildDate }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    version() {
      return process.env.PACKAGE_VERSION;
    },
    buildDate() {
      return process.env.PACKAGE_TIMESTAMP;
    },
    appName() {
      return process.env.VUE_APP_NAME;
    }
  }
}
</script>


<style lang="scss">
.jobs-footer-2::before {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    background-color: #adb5ba;

    @media screen and (min-width: 768px) {
      height: 880px;
    }
}

.footer-2-contents {
    position: relative;
    padding: 15px;
    background-color: #f2f2f2;
    border-radius: 0 0 150px 150px;

    .social {
      border: 1px solid #e2e5e6;
      color: #666 !important;
      font-size: 2.5rem;
      cursor: pointer;
      transition: 0.6s ease;
      border-radius: 0 0 150px 150px;

      .social-icon {
        transition: 0.6s ease;
      }
    }

    .social:hover {
      background-color: #fff;

      #icon-fb {
        color: #4267b2;
      }

      #icon-tw {
        color: #55acee;
      }

      #icon-yt {
        color: #f00;
      }

      #icon-ln {
        color: #2867B2
      }

      #icon-ig {
        color: #C13584
      }

    }
}

.footer-nav {
    position: relative;
    padding: 20px;
    text-align: left;

     @media screen and (max-width: 767px) {
      & {
        margin: 0 !important;
      }
    }

    .title {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #373d40;
    }

    #appstore-playstore {
        width: 180px;
    }

    ul {
        list-style: none;
        padding: 0;
        font-size: 15px;

        li {
            padding: 7px 0;
        }
    }
}

.copyright {
    color: #646b6f;
    font-size: 13px;
    display: flex;
    justify-content: space-evenly;
    padding: 0 100px;
    font-weight: 600;

    @media screen and (max-width: 767px) {
      & {
        margin: 0 !important;
      }
    }

    a {
        color: #646b6f;
    }
}

.real-footer {
    position: relative;

    .footer-nav {
      width: 80%;
      margin: auto;
    }
}

.version-text {
  text-align: center;
  font-size: 0.8rem;
  color: #646b6f;
}

.group-company {
  color: #658bc7;
  font-weight: 600;
  font-size: 0.9rem;
}
</style>
